import { render, staticRenderFns } from "./Regions.vue?vue&type=template&id=11bf53cc"
import script from "./Regions.vue?vue&type=script&lang=js"
export * from "./Regions.vue?vue&type=script&lang=js"
import style0 from "./Regions.vue?vue&type=style&index=0&id=11bf53cc&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports